export enum PLAY_VIDEO_USAGE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720841087
     */
    ACTIVATE_PLAY = 'PLAY.ACTIVATE_PLAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721248909
     */
    ALL_SITES_SELECTED = 'PLAY.ALL_SITES_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=739948118
     */
    CANNOT_EXCEED_QUOTA = 'PLAY.CANNOT_EXCEED_QUOTA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=457705311
     */
    CHINA_VIDEOS = 'PLAY.CHINA_VIDEOS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=457705497
     */
    CHINA_VIDEOS_COUNT = 'PLAY.CHINA_VIDEOS_COUNT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=541994134
     */
    CORPORATE_VIDEOS = 'PLAY.CORPORATE_VIDEOS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720841237
     */
    DEACTIVATE_PLAY = 'PLAY.DEACTIVATE_PLAY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720961143
     */
    DEACTIVATE_PLAY_FEATURE_DESCRIPTION = 'PLAY.DEACTIVATE_PLAY_FEATURE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720838005
     */
    EDIT_QUOTA = 'PLAY.EDIT_QUOTA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=740516217
     */
    EDIT_QUOTAS = 'PLAY.EDIT_QUOTAS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=277231895
     */
    EMPLOYEE_VIDEOS = 'PLAY.EMPLOYEE_VIDEOS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=277783848
     */
    EMPLOYEES_VIDEOS_COUNT = 'PLAY.EMPLOYEES_VIDEOS_COUNT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=743943120
     */
    OPTIMIZED_VIDEOS_QUOTA_NOTICE = 'PLAY.OPTIMIZED_VIDEOS_QUOTA_NOTICE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=541995496
     */
    OPTMIZED_VIDEOS = 'PLAY.OPTIMIZED_VIDEOS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=233963515
     */
    PLATFORM_OVERVIEW = 'LOOKER_PLATFORM_OVERVIEW_DASHBOARD_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=539121594
     */
    PLATFORM_USAGE = 'PLAY.PLATFORM_USAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=277782894
     */
    PLATFORM_VIDEOS_COUNT = 'PLAY.PLATFORM_VIDEOS_COUNT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720840673
     */
    PLAY_SETTINGS = 'PLAY.PLAY_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720887102
     */
    PLAY_STATUS = 'PLAY.PLAY_STATUS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720847004
     */
    QUOTA_EXCEEDED_WARNING = 'PLAY.QUOTA_EXCEEDED_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720686122
     */
    QUOTA_UNRESTRICTED_IF_EMPTY = 'PLAY.QUOTA_UNRESTRICTED_IF_EMPTY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=542108887
     */
    SHOW_SPECIFIC_SITE = 'PLAY.SHOW_SPECIFIC_SITE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721000352
     */
    SITES_OUT_OF_MANY = 'PLAY.SITES_OUT_OF_MANY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721000071
     */
    SITES_SELECTED = 'PLAY.SITES_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721429288
     */
    SITES_SELECTED_OUT_OF_MANY = 'PLAY.SITES_SELECTED_OUT_OF_MANY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546403031
     */
    UNABLE_TO_DISPLAY_PAGE = 'PLAY.UNABLE_TO_DISPLAY_PAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721364676
     */
    UPLOADING_VIDEO = 'PLAY.UPLOADING_VIDEO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=541339368
     */
    USAGE_PER_SITES = 'PLAY.USAGE_PER_SITES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721031437
     */
    VIDEO_ACCESSIBILITY_CONTEXT = 'PLAY.VIDEO_ACCESSIBILITY_CONTEXT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=355394086
     */
    VIDEO_ANALYTICS = 'LOOKER_VIDEO_DASHBOARD_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=542530102
     */
    VIDEO_QUOTA_NOT_CONFIGURED = 'PLAY.VIDEO_QUOTA_NOT_CONFIGURED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=276382214
     */
    VIDEO_USAGE = 'PLAY.VIDEO_USAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=281765360
     */
    VIDEO_USAGE_EXCEEDED = 'PLAY.VIDEO_USAGE_EXCEEDED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=281765402
     */
    VIDEO_USAGE_UNAVAILABLE = 'PLAY.VIDEO_USAGE_UNAVAILABLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=277223757
     */
    VIDEO_USAGE_WARNING_MESSAGE = 'PLAY.VIDEO_USAGE_WARNING_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=743936826
     */
    VIDEOS_PLATFORM_LIMIT = 'PLAY.VIDEOS_PLATFORM_LIMIT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=720953361
     */
    VIDEOS_USED = 'PLAY.VIDEOS_USED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=762295508
     */
    VIDEOS_USED_WARNING_ALLOWANCE = 'PLAY.VIDEO_USAGE_WARNING_ALLOWANCE',
}
